import { render, staticRenderFns } from "./edpWaterBg.vue?vue&type=template&id=6e25f858&"
import script from "./edpWaterBg.vue?vue&type=script&lang=js&"
export * from "./edpWaterBg.vue?vue&type=script&lang=js&"
import style0 from "./edpWaterBg.vue?vue&type=style&index=0&id=6e25f858&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports